import React from "react";
import { Check, ChevronRight } from "lucide-react";

export const WizardProgress = ({ steps, current, onJump }) => {
  const visible = steps.filter((s) => s.id !== "finish");
  return (
    <div className="flex items-center gap-1 overflow-x-auto no-scrollbar -mx-1 px-1" data-testid="wizard-progress" aria-label={`Etapa ${current + 1} de ${visible.length}`}>
      {visible.map((s, i) => {
        const done = i < current, active = i === current;
        return (
          <React.Fragment key={s.id}>
            {i > 0 && <ChevronRight className="h-3.5 w-3.5 text-muted-foreground/50 shrink-0" />}
            <button type="button" onClick={() => done && onJump(i)} disabled={!done} data-testid={`wizard-step-${s.id}`}
              className={`flex items-center gap-1.5 shrink-0 h-8 px-2 rounded-lg text-xs font-medium transition-colors ${active ? "bg-foreground text-background" : done ? "text-foreground hover:bg-accent" : "text-muted-foreground/70"}`}>
              <span className={`h-5 w-5 rounded-full text-[11px] font-bold flex items-center justify-center ${active ? "bg-background/20" : done ? "bg-secondary/15 text-secondary" : "bg-muted"}`}>{done ? <Check className="h-3 w-3" /> : i + 1}</span>
              <span className={active ? "" : "hidden sm:inline"}>{s.label}</span>
            </button>
          </React.Fragment>
        );
      })}
    </div>
  );
};

export const Chips = ({ options, value, onChange, testidPrefix }) => (
  <div className="flex flex-wrap gap-2">
    {options.map((o) => (
      <button key={o} type="button" onClick={() => onChange(o)} data-testid={`${testidPrefix}-${o}`}
        className={`h-11 px-4 rounded-xl border text-sm font-medium transition-colors active:scale-95 ${value === o ? "bg-foreground text-background border-foreground" : "bg-card border-border hover:border-foreground/40"}`}>
        {o}
      </button>
    ))}
  </div>
);
